import { createContext, } from 'react';
export const SelectContext = createContext({
    selected: 0,
});
export const SearchContext = createContext({
    search: '',
    onChangeOpen: () => { },
    onChangeSearch: () => { },
    inputRef: null,
    isOpen: false,
});
export const OpenContext = createContext({
    onChangeOpen: () => undefined,
    isOpen: false,
});
